import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE,  PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawSummary(doc, summary,grandTotal,) {
 

  console.log("values", grandTotal)

  autoTable(doc, {
     startY: doc.lastAutoTable.finalY + 20,

    margin: {
      left: 55,
    },
    //theme: "grid",
  ...PDF_TABLE_STYLE,

     head: [["Description", "%"]],

    body: [
       ["Freight Calculated on Total Store @", format(grandTotal.FreightRate)],
       ["Proforma on Cost Calculated on Total Labour @", format(grandTotal.ProformaRate)],
       
      
    ],



    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      cellPadding: 3,
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING,
      textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING,
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles: {
      0: {
        halign: "left",
        cellWidth: 60,
      },
      1: {
        halign: "right",
        cellWidth: 60,
      },
    },

   
  });
}

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}